import resume from '../assets/pdf/resume.pdf';
import img from "../assets/png/img-prof.jpg";

export const headerData = {
    name: 'Dnyaneshwar Magar',
    title: "Aspiring AI / ML Engineer",
    desciption: "Passionate AI/ML engineer and problem‑solver, driven by curiosity and a love for building intelligent solutions.",
    image: img,
    resumePdf: resume
}
